<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <v-container class="d-flex align-center pa-0 px-md-3">
        <router-link to="/">
          <v-img
            :src="require('@/assets/thumbnail_Condorcet_neg.c33101cd.png')"
            :max-width="$vuetify.breakpoint.smAndDown ? 168 : 196"
            contain
          ></v-img>
        </router-link>

        <v-spacer></v-spacer>

        <!-- ---------------------------------- Account Popover -------------------------------- -->

        <v-menu
          offset-y
          nudge-left="225"
          nudge-bottom="5"
          max-width="280px"
          v-if="isAuth"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              x-large
              v-on="on"
            >
              <v-avatar
                size="48"
              >
                <v-img
                  :src="user.gender === 'F' ?
                  require('@/assets/undraw_female_avatar_w3jk.svg') :
                  require('@/assets/undraw_profile_pic_ic5t.svg')"
                ></v-img>
              </v-avatar>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title">
                  {{ user.firstName }} {{ user.lastName }}
                </v-list-item-title>

                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list
            nav
            dense
          >
            <v-list-item to="/profile">
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Mon profil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/vacant-jobs">
              <v-list-item-icon>
                <v-icon>mdi-briefcase</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Emplois Vacants</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/applications">
              <v-list-item-icon>
                <v-icon>mdi-clipboard-list</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Mes postulations</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="signOut">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Déconnexion</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- ----------------------------------------------------------------------------------- -->

        <template v-else>
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            text
            to="/login"
          >
            Connexion
          </v-btn>

          <v-btn
            v-else
            icon
            to="/login"
          >
            <v-icon>mdi-login</v-icon>
          </v-btn>
        </template>
      </v-container>
    </v-app-bar>

    <v-main :style="{ 'background-color' : '#f2f5f8' }">
      <router-view
        @open-legal-notice="legalNoticeDialogIsActive = true"
      ></router-view>

      <notification-snackbar></notification-snackbar>
    </v-main>

    <v-footer
      app
      color="secondary"
      dark
      class="justify-center"
    >
      <legal-notice-dialog v-model="legalNoticeDialogIsActive"></legal-notice-dialog>
      <span class="mx-2">|</span>
      <help-dialog v-model="helpDialogIsActive"></help-dialog>
    </v-footer>
  </v-app>
</template>

<script>
import NotificationSnackbar from '@/components/NotificationSnackbar.vue';
import HelpDialog from '@/components/HelpDialog.vue';
import LegalNoticeDialog from '@/components/LegalNoticeDialog.vue';
import { mapGetters, mapState, mapActions } from 'vuex';

const axios = require('axios').default;

export default {
  name: 'App',

  components: {
    'notification-snackbar': NotificationSnackbar,
    'help-dialog': HelpDialog,
    'legal-notice-dialog': LegalNoticeDialog,
  },

  data: () => ({
    helpDialogIsActive: false,
    legalNoticeDialogIsActive: false,
  }),

  created() {
    axios.interceptors.response.use((response) => response, (error) => {
      if (error.response.status === 401 && error.response.config.url !== 'signin') {
        this.logOut();
        if (this.$route.name !== 'Login') this.$router.push('/login');
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Votre session a expiré, reconnectez-vous',
        });
      }
      return Promise.reject(error);
    });
    if (this.isAuth) {
      this.getUserData().catch(() => {
        if (this.$route.name !== 'Login') this.$router.push('/login');
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Impossible de récupérer les infos de votre profil, reconnectez-vous',
        });
      });
    }
  },

  computed: {
    ...mapGetters(['isAuth']),
    ...mapState(['user']),
  },

  methods: {
    ...mapActions(['getUserData', 'logOut']),
    signOut() {
      this.logOut();
      if (this.$route.name !== 'Home') this.$router.push('/');
    },
  },
};
</script>
